import Vue from "vue";
import Router from "vue-router";
import onlineActivity from "./onlineActivity"; //在线活动
import eduitCenter from "./eduitCenter"; //教育服务专区
import raffle from "./raffle"; //教育服务专区
import sign from "./sign"; //就餐记录
import wish from "./wish"; //许愿墙
import simplePhoto from "./simplePhoto"; // 随手拍
import largeWithdrawal from "./largeWithdrawal"; // 大额取款预约
import creditscore from "./creditscore"; // 信用分
import springCard from "./springCard"; // 春城卡专区

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

const _import_ = file => () => import("../views/" + file + ".vue");
//根据环境 设置 打包后访问路径
var base = "";
if (process.env.NODE_ENV == "development") {
  //测试环境
  base = "/h5_t/";
} else if (process.env.NODE_ENV == "test") {
  //灰度
  base = "/ccsmkenc/";
} else if (process.env.NODE_ENV == "production") {
  //正式环境
  base = "/enc/";
}
export default new Router({
   mode: "history", //去除url上的#
  // base: "/h5_t/",
  //  base: "/ccsmkenc/",
   base: "/enc/",
  // base: base,
  routes: [
    {
      path: "/",
      redirect: "/rights/rights-center"
    },
    // 汽博会
    // ticket-information Autobots
    {
      path: "/Autobots/Promotion-code",
      component: _import_("Autobots/Promotion-code"),
      meta: {
        title: "推广码"
      }
    },
    {
      path: "/Autobots/Autobots",
      component: _import_("Autobots/Autobots"),
      meta: {
        title: "购票信息"
      }
    },
    {
      path: "/exam/pop-up",
      component: _import_("exam/pop-up"),
      meta: {
        title: "确定交卷弹窗"
      }
    },
    // 答题页面
    // pop-up
    {
      // result 试卷名称--答完题
      path: "/exam/result",
      component: _import_("exam/result"),
      meta: {
        title: "长春市民卡考试"
      }
    },
    {
      path: "/exam/pop-up",
      component: _import_("exam/pop-up"),
      meta: {
        title: "长春市民卡考试"
      }
    },
    {
      path: "/exam/exam-number",
      component: _import_("exam/exam-number"),
      meta: {
        title: "长春市民卡考试"
      }
    },
    {
      path: "/exam/exam-one",
      component: _import_("exam/exam-one"),
      meta: {
        title: "长春市民卡考试"
      }
    },
    {
      path: "/exam/exam-two",
      component: _import_("exam/exam-two"),
      meta: {
        title: "长春市民卡考试"
      }
    },
    {
      path: "/exam/exam-review",
      component: _import_("exam/exam-review"),
      meta: {
        title: "长春市民卡考试"
      }
    },
    {
      path: "/exam/exam-three",
      component: _import_("exam/exam-three"),
      meta: {
        title: "长春市民卡考试"
      }
    },
    {
      path: "/exam/exam-foue",
      component: _import_("exam/exam-foue"),
      meta: {
        title: "长春市民卡考试"
      }
    },
    {
      path: "/exam/retrospect",
      component: _import_("exam/retrospect"),
      meta: {
        title: "长春市民卡考试"
      }
    },
    {
      path: "/exam/exam-review",
      component: _import_("exam/exam-review"),
      meta: {
        title: "长春市民卡考试"
      }
    },
    // ====答题页面
    //公告详情页
    {
      path: "/notice/notice",
      component: _import_("notice/notice"),
      meta: {
        title: "详情页"
      }
    },
    {
      path: "/notice/textdetail",
      component: _import_("notice/textdetail"),
      meta: {
        title: "第二届东北图书博览会线上培训"
      }
    },
    {
      path: "/agreement/register",
      component: _import_("agreement/register"),
      meta: {
        title: "注册协议"
      }
    },
    {
      path: "/agreement/privacy",
      component: _import_("agreement/privacy"),
      meta: {
        title: "隐私政策"
      }
    },
    {
      path: "/agreement/unionpayPrivacy",
      component: _import_("agreement/unionpayPrivacy"),
      meta: {
        title: "银联用户服务协议"
      }
    },
    {
      path: "/agreement/thirdPartyDisclaimer",
      component: _import_("agreement/thirdPartyDisclaimer"),
      meta: {
        title: "第三方服务免责协议"
      }
    },
    {
      path: "/agreement/thirdPartyDisclaimerWord",
      component: _import_("agreement/thirdPartyDisclaimerWord"),
      meta: {
        title: "第三方服务免责协议"
      }
    },
    {
      path: "/agreement/freePay",
      component: _import_("agreement/freePay"),
      meta: {
        title: "快捷支付授权协议"
      }
    },
    {
      path: "/apply/index",
      component: _import_("apply/index"),
      meta: {
        title: "市民卡"
      }
    },
    {
      path: "/apply/apply",
      component: _import_("apply/apply"),
      meta: {
        title: "申领市民卡"
      }
    },
    {
      path: "/apply/account-open",
      component: _import_("apply/account-open"),
      meta: {
        title: "市民卡账户开通"
      }
    },
    {
      path: "/apply/account-loss",
      component: _import_("apply/account-loss"),
      meta: {
        title: "市民卡账户开通"
      }
    },
    {
      path: "/apply/account-unbund",
      component: _import_("apply/account-unbund"),
      meta: {
        title: "市民卡解绑"
      }
    },
    {
      path: "/apply/account-result",
      component: _import_("apply/account-result"),
      meta: {
        title: "办理结果"
      }
    },
    {
      path: "/apply/signature",
      component: _import_("apply/signature"),
      meta: {
        title: "请横向签字"
      }
    },
    {
      path: "/apply/submit-result",
      component: _import_("apply/submit-result"),
      meta: {
        title: "提交结果"
      }
    },
    {
      path: "/apply/submit-result",
      component: _import_("apply/submit-result"),
      meta: {
        title: "提交结果"
      }
    },
    {
      path: "/rights/rights-center",
      component: _import_("rights/rights-center"),
      meta: {
        title: "权益中心"
      }
    },
    {
      path: "/rights/rights-detail",
      component: _import_("rights/rights-detail"),
      meta: {
        title: "权益详情"
      }
    },
    {
      path: "/scanCode/goods-info",
      component: _import_("scanCode/goods-info"),
      meta: {
        title: "信息详情"
      }
    },
    {
      path: "/scanCode/person-info",
      component: _import_("scanCode/person-info"),
      meta: {
        title: "人员信息"
      }
    },
    {
      path: "/scanCode/pay-info",
      component: _import_("scanCode/pay-info"),
      meta: {
        title: "支付"
      }
    },
    {
      path: "/scanCode/unionpay",
      component: _import_("scanCode/unionpay"),
      meta: {
        title: "支付"
      }
    },
    {
      path: "/scanCode/unionpay-pending",
      component: _import_("scanCode/unionpay-pending"),
      meta: {
        title: "支付结果"
      }
    },
    {
      path: "/scanCode/unionpay-success",
      component: _import_("scanCode/unionpay-success"),
      meta: {
        title: "支付结果"
      }
    },
    {
      path: "/scanCode/pay-instruction",
      component: _import_("scanCode/pay-instruction"),
      meta: {
        title: "付款说明"
      }
    },
    {
      path: "/scanCode/not-pay",
      component: _import_("scanCode/not-pay"),
      meta: {
        title: "未完成支付"
      }
    },

    {
      path: "/scanCode/pay-success",
      component: _import_("scanCode/pay-success"),
      meta: {
        title: "支付结果"
      }
    },
    {
      path: "/scanCode/pay-fail",
      component: _import_("scanCode/pay-fail"),
      meta: {
        title: "支付结果"
      }
    },
    {
      path: "/scanCode/pay-pending",
      component: _import_("scanCode/pay-pending"),
      meta: {
        title: "支付结果"
      }
    },
    {
      path: "/scanCode/pay-record",
      component: _import_("scanCode/pay-record"),
      meta: {
        title: "我的账单"
      }
    },
    {
      path: "/scanCode/record-detail",
      component: _import_("scanCode/record-detail"),
      meta: {
        title: "我的账单"
      }
    },
    {
      path: "/scanCode/balance-record",
      component: _import_("scanCode/balance-record"),
      meta: {
        title: "收支记录"
      }
    },
    {
      path: "/scanCode/balance-bill",
      component: _import_("scanCode/balance-bill"),
      meta: {
        title: "收支账单"
      }
    },
    {
      path: "/school/school-info",
      component: _import_("school/school-info"),
      meta: {
        title: "市民码"
      }
    },
    {
      path: "/delivery/delivery",
      component: _import_("delivery/delivery"),
      meta: {
        title: "快递查询"
      }
    },
    {
      path: "/delivery/result",
      component: _import_("delivery/result"),
      meta: {
        title: "快递查询"
      }
    },
    {
      path: "/transportation/index",
      component: _import_("transportation/index"),
      meta: {
        title: "轨道首末班查询"
      }
    },
    {
      path: "/transportation/search",
      component: _import_("transportation/search"),
      meta: {
        title: "交通查询"
      }
    },
    {
      path: "/transportation/bus-search",
      component: _import_("transportation/bus-search"),
      meta: {
        title: "公交查询"
      }
    },
    {
      path: "/transportation/line-info",
      component: _import_("transportation/line-info"),
      meta: {
        title: "线路信息"
      }
    },
    {
      path: "/transportation/site-info",
      component: _import_("transportation/site-info"),
      meta: {
        title: "站点信息"
      }
    },
    {
      path: "/transportation/bybus",
      component: _import_("transportation/bybus"),
      meta: {
        title: "免费线路"
      }
    },
    {
      path: "/transportation/bus-confirm",
      component: _import_("transportation/bus-confirm"),
      meta: {
        title: "乘坐线路"
      }
    },
    {
      path: "/transportation/bus-list",
      component: _import_("transportation/bus-list"),
      meta: {
        title: "免费线路"
      }
    },
    {
      path: "/feedback/feedback",
      component: _import_("feedback/feedback"),
      meta: {
        title: "意见反馈"
      }
    },
    {
      path: "/feedback/result",
      component: _import_("feedback/result"),
      meta: {
        title: "提交成功"
      }
    },
    {
      path: "/feedback/feedbackList",
      component: _import_("feedback/feedbackList"),
      meta: {
        title: "我的反馈"
      }
    },
    {
      path: "/feedback/feedbackDetail",
      component: _import_("feedback/feedbackDetail"),
      meta: {
        title: "问题反馈详情"
      }
    },
    {
      // download-one
      path: "/download/download-one",
      component: _import_("download/download-one"),
      meta: {
        title: "下载1"
      }
    },
    {
      path: "/download/download",
      component: _import_("download/download"),
      meta: {
        title: "下载"
      }
    },
    {
      path: "/download/download-active",
      component: _import_("download/download-active"),
      meta: {
        title: "下载"
      }
    },
    {
      path: "/download/download-video",
      component: _import_("download/downLoad-video"),
      meta: {
        title: "下载"
      }
    },
    {
      path: "/download/xiazai",
      component: _import_("download/xiazai"),
      meta: {
        title: "下载"
      }
    },
    {
      path: "/download/download-c555",
      component: _import_("download/download-c555"),
      meta: {
        title: "下载"
      }
    },
    {
      path: "/download/download-c888",
      component: _import_("download/download-c888"),
      meta: {
        title: "下载"
      }
    },
    {
      path: "/download/download-auto",
      component: _import_("download/download-auto"),
      meta: {
        title: "下载"
      }
    },
    {
      path: "/showcode/information",
      component: _import_("showcode/information"),
      meta: {
        title: "信息录入"
      }
    },
    {
      path: "/showcode/code",
      component: _import_("showcode/code"),
      meta: {
        title: "二维码"
      }
    },
    {
      path: "/showcode/scanCode",
      component: _import_("showcode/scanCode"),
      meta: {
        title: "扫一扫"
      }
    },
    {
      path: "/showcode/visitCard",
      component: _import_("showcode/visitCard"),
      meta: {
        title: "参观证"
      }
    },
    {
      path: "/agreement/busRegister",
      component: _import_("agreement/busRegister"),
      meta: {
        title: "乘车码用户服务协议"
      }
    },
    {
      path: "/agreement/busPrivacy",
      component: _import_("agreement/busPrivacy"),
      meta: {
        title: "隐私政策"
      }
    },
    {
      path: "/agreement/problem",
      component: _import_("agreement/problem"),
      meta: {
        title: "常见问题"
      }
    },
    {
      path: "/agreement/trainPrivacy",
      component: _import_("agreement/trainPrivacy"),
      meta: {
        title: "隐私政策"
      }
    },
    {
      path: "/agreement/trainRegister",
      component: _import_("agreement/trainRegister"),
      meta: {
        title: "用户服务协议"
      }
    },
    {
      path: "/redPacket/index",
      component: _import_("redPacket/index"),
      meta: {
        title: "红包领取"
      }
    },
    {
      path: "/redPacket/receive-fail",
      component: _import_("redPacket/receive-fail"),
      meta: {
        title: "已领取"
      }
    },
    {
      path: "/redPacket/receive-success",
      component: _import_("redPacket/receive-success"),
      meta: {
        title: "领取成功"
      }
    },
    {
      path: "/redPacket/packet-detail",
      component: _import_("redPacket/packet-detail"),
      meta: {
        title: "红包详情"
      }
    },
    {
      path: "/redPacket/packet-rule",
      component: _import_("redPacket/packet-rule"),
      meta: {
        title: "使用规则"
      }
    },
    {
      path: "/redPacket/red-packet",
      component: _import_("redPacket/red-packet"),
      meta: {
        title: "现金红包"
      }
    },
    {
      path: "/redPacket/transaction-detail",
      component: _import_("redPacket/transaction-detail"),
      meta: {
        title: "现金红包交易明细"
      }
    },
    {
      path: "/loading/loading",
      component: _import_("loading/loading"),
      meta: {
        title: "跳转中"
      }
    },
    {
      path: "/lifePay/index",
      component: _import_("lifePay/index"),
      meta: {
        title: "生活缴费"
      }
    },
    {
      path: "/lifePay/common",
      component: _import_("lifePay/common"),
      meta: {
        title: "常用户号管理"
      }
    },
    {
      path: "/lifePay/select",
      component: _import_("lifePay/select"),
      meta: {
        title: "选择缴费单位"
      }
    },
    {
      path: "/lifePay/pay",
      component: _import_("lifePay/pay")
    },
    {
      path: "/lifePay/payTV",
      component: _import_("lifePay/payTV")
    },
    {
      path: "/lifePay/record",
      component: _import_("lifePay/record"),
      meta: {
        title: "缴费记录"
      }
    },
    {
      path: "/lifePay/pay-pending",
      component: _import_("lifePay/pay-pending"),
      meta: {
        title: "支付结果"
      }
    },
    {
      path: "/lifePay/pay-fail",
      component: _import_("lifePay/pay-fail"),
      meta: {
        title: "支付结果"
      }
    },
    {
      path: "/lifePay/pay-success",
      component: _import_("lifePay/pay-success"),
      meta: {
        title: "支付结果"
      }
    },
    {
      path: "/lifePay/life-way",
      component: _import_("lifePay/life-way"),
      meta: {
        title: "如何查询户号"
      }
    },
    {
      path: "/lifePay/life-agreement",
      component: _import_("lifePay/life-agreement"),
      meta: {
        title: "生活缴费协议"
      }
    },
    {
      path: "/bank/result",
      component: _import_("bank/result"),
      meta: {
        title: "签约"
      }
    },
    {
      path: "/bank/openpay",
      component: _import_("bank/openpay"),
      meta: {
        title: "快捷支付"
      }
    },
    {
      path: "/bank/bankNotice",
      component: _import_("bank/bankNotice"),
      meta: {
        title: "银联改造说明"
      }
    },

    {
      path: "/wage/wage",
      component: _import_("wage/wage"),
      meta: {
        title: "我的工资"
      }
    },
    {
      path: "/wage/wage-list",
      component: _import_("wage/wage-list"),
      meta: {
        title: "工资查询"
      }
    },
    {
      path: "/wage/retirement-wage",
      component: _import_("wage/retirement-wage"),
      meta: {
        title: "离退休工资"
      }
    },
    {
      path: "/wage/retirement-list",
      component: _import_("wage/retirement-list"),
      meta: {
        title: "离退休工资查询"
      }
    },
    {
      path: "/graph/graph",
      component: _import_("graph/graph"),
      meta: {
        title: "码上长春"
      }
    },
    {
      path: "/course/course",
      component: _import_("course/course"),
      meta: {
        title: "市民卡上线"
      }
    },
    {
      path: "/travel/index",
      component: _import_("travel/index"),
      meta: {
        title: "公园票务"
      }
    },
    {
      path: "/travel/index1",
      component: _import_("travel/index1"),
      meta: {
        title: "公园票务1"
      }
    },
    {
      path: "/travel/advertisment",
      component: _import_("travel/advertisment"),
      meta: {
        title: "长春农博园"
      }
    },
    {
      path: "/travel/my-order",
      component: _import_("travel/my-order"),
      meta: {
        title: "我的门票"
      }
    },
    {
      path: "/travel/order-detail",
      component: _import_("travel/order-detail"),
      meta: {
        title: "订单详情"
      }
    },
    {
      path: "/travel/refund",
      component: _import_("travel/refund"),
      meta: {
        title: "退款"
      }
    },
    {
      path: "/travel/code",
      component: _import_("travel/code"),
      meta: {
        title: "门票码"
      }
    },
    {
      path: "/travel/jytticket",
      component: _import_("travel/jytticket"),
      meta: {
        title: "净月潭"
      }
    },
    {
      path: "/travel/dsticket",
      component: _import_("travel/dsticket"),
      meta: {
        title: "雕塑公园"
      }
    },
    {
      path: "/travel/wmticket",
      component: _import_("travel/wmticket"),
      meta: {
        title: "伪满皇宫"
      }
    },
    {
      path: "/travel/hxcticket",
      component: _import_("travel/hxcticket"),
      meta: {
        title: "天定山滑雪场"
      }
    },
    {
      path: "/travel/bxticket",
      component: _import_("travel/bxticket"),
      meta: {
        title: "冰雪新天地"
      }
    },
    {
      path: "/travel/ticket-information",
      component: _import_("travel/ticket-information"),
      meta: {
        title: "汽博会"
      }
    },
    {
      path: "/travel/nbyticket",
      component: _import_("travel/nbyticket"),
      meta: {
        title: "农博园"
      }
    },
    {
      path: "/travel/jytSkiing",
      component: _import_("travel/jytSkiing"),
      meta: {
        title: "净月潭滑雪场"
      }
    },
    {
      path: "/travel/lhsticket",
      component: _import_("travel/lhsticket"),
      meta: {
        title: "世茂莲花山滑雪场"
      }
    },
    {
      path: "/travel/ticket-detail",
      component: _import_("travel/ticket-detail"),
      meta: {
        title: "购票信息"
      }
    },
    {
      path: "/saleBuy/index",
      component: _import_("saleBuy/index"),
      meta: {
        title: "惠购长春"
      }
    },
    {
      path: "/saleBuy/iqiyi",
      component: _import_("saleBuy/iqiyi")
    },
    {
      path: "/saleBuy/media",
      component: _import_("saleBuy/media"),
      meta: {
        title: "吉视传媒"
      }
    },
    {
      path: "/saleBuy/ticket-detail",
      component: _import_("saleBuy/ticket-detail"),
      meta: {
        title: "购票信息"
      }
    },
    {
      path: "/saleBuy/my-order",
      component: _import_("saleBuy/my-order"),
      meta: {
        title: "我的订单"
      }
    },
    {
      path: "/saleBuy/order-detail",
      component: _import_("saleBuy/order-detail"),
      meta: {
        title: "订单详情"
      }
    },
    {
      path: "/questions/questions",
      component: _import_("questions/questions"),
      meta: {
        title: "常见问题"
      }
    },
    {
      path: "/question_list",
      component: _import_("questions/QAList"),
      meta: {
        title: "常见问题"
      }
    },
    {
      path: "/questions/virtualAgent",
      component: _import_("questions/virtualAgent"),
      meta: {
        title: "卡小秘"
      }
    },
    {
      path: "/information/detail",
      component: _import_("information/detail"),
      meta: {
        title: "最新资讯"
      }
    },
    {
      path: "/information/banner-detail",
      component: _import_("information/banner-detail"),
      meta: {
        title: "详情"
      }
    },
    {
      path: "/winners/winners",
      component: _import_("winners/winners"),
      meta: {
        title: "中奖公告"
      }
    },
    {
      path: "/course/sport",
      component: _import_("course/sport"),
      meta: {
        title: "体育消费券公告"
      }
    },
    {
      path: "/course/vouchers",
      component: _import_("course/vouchers"),
      meta: {
        title: "超市消费券公告"
      }
    },
    {
      path: "/course/department",
      component: _import_("course/department"),
      meta: {
        title: "百货消费券公告"
      }
    },
    {
      path: "/crsc/report",
      component: _import_("crsc/report"),
      meta: {
        title: "企业信用报告"
      }
    },
    {
      path: "/crsc/info",
      component: _import_("crsc/info"),
      meta: {
        title: "企业信用报告"
      }
    },
    {
      path: "/childrenLibrary/home",
      component: _import_("childrenLibrary/home"),
      meta: {
        title: "少儿图书馆"
      }
    },
    {
      path: "/coupon/coouponlist",
      component: _import_("coupon/coouponlist"),
      meta: {
        title: "新用户权益中心"
      }
    },
    {
      path: "/coupon/changeInviteCode",
      component: _import_("coupon/changeInviteCode"),
      meta: {
        title: "个人邀请码"
      }
    },
    {
      path: "/coupon/index",
      component: _import_("coupon/index"),
      meta: {
        title: "新用户权益中心"
      }
    },
    {
      path: "/cooperation/index",
      component: _import_("cooperation/index"),
      meta: {
        title: "生态合作招募"
      }
    },
    // {
    //   path: "/question_list",
    //   component: _import_("coupon/questionList"),
    //   meta: {
    //     title: "常见咨询"
    //   }
    // },
    {
      path: "/youth_activity",
      component: _import_("activity/youthActivity"),
      meta: {
        title: "青协活动"
      }
    },
    {
      path: "/bankActivity",
      component: _import_("activity/NatureBankActivity"),
      meta: {
        title: "邮储银行"
      }
    },
    // 视频播放器
    {
      path: "/video/player",
      component: _import_("video/player"),
      meta: {
        title: "播放器"
      }
    },
    {
      path: "/Metro/map",
      component: _import_("Metro/map"),
      meta: {
        title: "地铁图"
      }
    },
    {
      path: "/Metro/timeTable",
      meta: {
        title: "轨道时刻表"
      },
      component: () => import("../views/Metro/timeTable.vue")
    },
    ...onlineActivity, //在线活动
    ...eduitCenter, //教育活动专区
    ...raffle, //转盘
    ...sign, //就餐记录
    ...wish, //许愿墙
    ...simplePhoto, //随手拍
    ...largeWithdrawal, //大额取款预约
    ...creditscore, //信用分
    ...springCard //春城卡专区
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js